import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import StripePaywall from "./shared/StripePaywall";

const apiUrl = process.env.REACT_APP_API_URL || "https://api-backend.full-trucking-service.com/api";

const PrivateRoute = () => {
  const [status, setStatus] = useState("loading"); 
  // status: loading | active | trial | expired | unauthenticated

  useEffect(() => {
    const checkAccess = async () => {
      const token = localStorage.getItem("token");
      const tokenExpiration = localStorage.getItem("tokenExpiration");
      const clientId = localStorage.getItem("clientId");

      // 1. verificăm tokenul
      if (!token || !tokenExpiration || new Date() >= new Date(tokenExpiration)) {
        setStatus("unauthenticated");
        return;
      }

      try {
        // 2. verificăm abonamentul în backend
 const res = await axios.get(
  `https://api-backend.full-trucking-service.com/api/clients/${clientId}`,
  { headers: { Authorization: `Bearer ${token}` } }
);

        const client = res.data;

        if (client.subscriptionStatus === "active") {
          setStatus("active");
        } else {
          const now = new Date();
          if (client.trialEndsAt && new Date(client.trialEndsAt) > now) {
            setStatus("trial"); // trial încă valabil
          } else {
            setStatus("expired"); // trial terminat, abonament inactiv
          }
        }
      } catch (err) {
        console.error("Error checking subscription:", err);
        setStatus("unauthenticated");
      }
    };

    checkAccess();
  }, []);

  if (status === "loading") return <div>Loading...</div>;
  if (status === "unauthenticated") return <Navigate to="/login" replace />;
  if (status === "expired") return <StripePaywall />;

  // ✅ dacă e activ sau trial → acces
  return <Outlet />;
};

export default PrivateRoute;
